<template>
    <Container>
      <div class="flex-wrap flex-between" style="padding:0 10px">
        <Toolbar
          :items="tools"
          v-model="filter"
          :counts="counts"
          @on-event="handleEvent"
        />

        <div class="flex-wrap">
        <Button style="margin-right:5px" icon="md-add" type="primary" @click="showCreateForm">新建项目</Button>
        <Button style="margin-left:5px" icon="md-download" @click="exportExcel" />
        </div>
      </div>

      <div class="table-wrap" style="flex-grow:1;position;relative">
        <BaseTable
          ref="table"
          :columns="columns"
          :data="items"
          border
          :page="page"
          :page-size="pagesize"
          @event="handleEvent"
          :loading="loading"
          :count="total"
        />
      </div>

      <Editor
        ref="editor"
        v-model="showEditor"
        :data="current"
        model="BU_Bid_Opening_Project"
        @on-event="handleEvent"
        :width="900"
      />
    </Container>
  </template>

<script>
import Container from '@/components/app/container';
import Toolbar from '@/components/app/toolbar';
import Editor from '@/components/model/editor';
import moment from 'moment';
export default {
  routerOption: {
    as_default: true,
  },
  components: {Container, Toolbar, Editor},
  data() {
    return {
      filter: {

      },
      showEditor: false,
      items: [],
      loading: false,
      current: {},
      formData: {},
      page: 1,
      pagesize: 20,
      total: 10,
      counts: {
        '草稿': 0,
        '审核中': 0,
        '审核通过': 0,
        '不通过': 0,
      },
      order: {
        key:'created_at',
        order:'desc'
      },
    };
  },
  methods: {
    CreateNext(item) {
      this.Error("下一步工作还在开发中，请稍后再试")
      return
      this.Confirm(`将为项目创建<span style='color:red;margin:0 3px'>${item['project_info.name']}</span>创建对应的开标工作, 是否继续?`, ()=>{
        this.loading = true;
        this.$api.post('/business/bid_opening_projects/create-work', {id: item.id}).then((res)=>{
          this.getData()
          this.Confirm('合同编审工作已经创建成功,是否跳转', ()=>{
            this.RouteTo('open');
          });
        });
      });
    },
    showCreateForm() {
      this.current = {};
      this.formData = {};
      this.showEditor = true;
    },
    Edit(item) {
      this.loadingEditor = true;
      this.showEditor = true;
      this.$api.get(`business/bid_opening_projects/${item.id}?edit=1`).then((res)=>{
        this.current = res.data.data;
        this.loadingEditor = false;
        this.formData = cloneDeep(this.current);
        this.showEditor = true;
      }).catch((e)=>{
        this.loadingEditor = false;
        this.loadingEditorError = true;
      });
    },
    exportExcel() {
      this.$refs.table.exportExcel();
    },
    getStatusCounts() {
      this.$api.getCounts('/business/bid_opening_projects', {
        count_by: 'status',
      }).then((res)=>{
        this.counts = Object.assign(this.counts, res.data.data);
      });
    },
    getData() {
      this.loading = true;
      this.$api.afterLogin(()=>{
        this.$api.getPaged('/business/bid_opening_projects', {
          page: this.page,
          pagesize: this.pagesize,
          order: this.order,
          plain:true,
          filter: this.filter,
          related: ['project_info', 'bid_info', 'bid_bond', 'bid_open_info', 'bid_files', 'bid_open_record'],
        }).then((res)=>{
          const {count, list} = res.data.data;
          list.forEach((l)=>{
            if (l.bid_open_info) {
              Object.assign(l, l.bid_open_info);
            }

            if (l.bid_info) {
              Object.assign(l, l.bid_info);
            }
            if (l.project_info) {
              Object.assign(l, l.project_info);
            }
            if (l.bid_bond) {
              delete l.bid_bond.id;
              delete l.bid_bond.project_id;
              Object.assign(l, l.bid_bond);
            }
          });
          this.items = list;
          this.total = count;
          this.loading = false;
        }).catch((e)=>{
          this.Error(e);
        }).finally(()=>{
          this.loading = false;
        });
      });
    },
    createItem(model) {
      this.$api.post('/business/bid_opening_projects', model).then((res)=>{
        this.$Notice.success({title: '创建成功'});
        this.showEditor = false;
        this.getData();
      }).finally(()=>{
        this.$refs.editor.stopLoading();
      });
    },
    updateItem(model) {
      const id = this.current.id;
      this.$api.patch(`/business/bid_opening_projects/${id}`, model).then((res)=>{
        this.$Notice.success({title: '修改成功'});
        this.showEditor = false;
        this.getData();
      }).finally(()=>{
        this.$refs.editor.stopLoading();
      });
    },
    handleDelete(item) {
      this.Confirm(`即将删除此项目<span style="color:var(--error)">${item['project_info.name']}</span>，是否继续?`, ()=>{
        this.$api.delete('/business/bid_opening_projects/'+item.id).then((res)=>{
          this.$Notice.success({title: '删除成功'});
          this.getData();
        });
      });
    },
    handleOpen(project) {
      this.$store.commit('session/push_project', {
        id: project.id,
        name: project.name,
      });
      this.RouteTo('/core/projects/'+project.id+'/bid');
    },
    handleEvent({type, key, value, data}) {
      const eventMap = {
        'add': this.showCreateForm,
        'search': this.getData,
        'create': this.createItem,
        'refresh': ()=>{
          this.getStatusCounts();
          this.getData();
        },
        'update': this.updateItem,
        'tab-change': this.getData,
        'page-change': ()=>{
          this.page = data;
          this.getData();
        },
        'page-size-change': ()=>{
          this.pagesize = data;
          this.getData();
        },
        'sort': ()=>{
          if (!data || !data.key) {
            this.order = null;
          } else {
            this.order = data;
          }
          this.getData();
        },
      };


      let eventHandler = eventMap[type];
      if (eventHandler) {
        eventHandler(value);
      } else {
        eventHandler = eventMap[key];
        if (eventHandler) {
          eventHandler(value);
        }
      }
    },
  },
  computed: {
    tools() {
      return [{
        key: 'search',
        placeholder: '输入项目名称/招标单位/搜索',
        type: 'search',
        maxWidth: 200,
      }, {
        key: 'bid_open_info.bid_type',
        type: 'tabs',
        subs: [{
          key: '一类项目',
          icon: 'date',
          countable: true,
          name: '一类项目',
        }, {
          key: '二类项目',
          icon: 'file',
          countable: true,
          name: '二类项目',
        }],
      }, {
        key: 'bid_open_info.is_bid',
        type: 'tabs',
        subs: [{
          key: false,
          icon: 'date',
          countable: true,
          name: '已中标',
        }, {
          key: true,
          icon: 'file',
          countable: true,
          name: '未中标',
        }],
      }, {
        key: 'bid_open_info.is_exception',
        type: 'tabs',
        subs: [{
          key: true,
          icon: 'date',
          countable: true,
          name: '投标异常',
        }],
      }, {
        key: 'refresh',
        icon: 'md-refresh',
        type: 'icon-button',
      }];
    },
    columns() {
      const that = this;
      return [
        {type: 'index', width: 80, title: '序号'},
        {key: 'project_info.code', width: 80, title: '编号',type:'code'},
        {key: 'project_info.name', width: 240, title: '项目名称', sortable: 'custom',
          render: (h, {row})=>{
            const icon = h('BaseIcon', {props: {icon: 'Building-', size: 16, color: 'var(--primary)'}, style: 'margin-left:10px;margin-right:5px;'});
            let tag = h('img', {attrs: {
              src: 'https://nbgz-pmis-1257839135.cos.ap-shanghai.myqcloud.com/beauty/new.gif',
            }, style: 'width:30px;height:15px;margin-left:5px;margin-right:10px;'});
            let tag2 = h('span', {attrs:{
              title:"此项目是直接录入项目，非流转项目"
            },style: {color: 'var(--hover-text)',padding:'0 2px',background:'var(--primary)',borderRadius:'2px',fontSize:'10px',marginLeft:'3px'}}, 'N');
            if (moment().subtract(3, 'days').isAfter(moment(row.created_at))) {
              tag = '';
            }
            if(row.bid_work_project_id){
              tag2 = ''
            }
            const nameText = row['project_info.name'];
            const shortnameText = row['project_info.shortname'];
            const name = h('div', {attrs: {title: nameText}, style: 'width:calc(100% - 50px;);overflow:hidden;'}, [shortnameText ||nameText, tag2]);
            return h('div', {
              class: 'flex-wrap',
              style: {
                color: 'var(--primary)',
                fontWeight: 'bold',
                textAlign: 'left',
                cursor: 'pointer',
              },
              on: {
                click: ()=>{
                  this.Edit(row);
                },
              },
            }, [icon, name, tag]);
          },
        },
        {key: 'bid_open_info.charger_id', type: 'user', width: 100, title: '负责人', sortable: 'custom',

        },
        {key: 'bid_info.published_at', width: 120, title: '公告起始日期', sortable: 'custom',
          render: (h, {row})=>{
            let m = moment(row['bid_info.published_at'])
            return h('span', m.isValid() ? m.format('YYYY-MM-DD') : '-');
          }},
        {key: 'bid_open_info.bid_type', width: 100, title: '投标类型', type: 'type', option: {
          type: ['一类项目', '二类项目'],
          colors:['var(--primary)','var(--subtext2)']
        }},
        {key: 'bid_open_info.target_type', width: 100, title: '标的类型',
          type: 'type', option: {
            type: ['全资', '监理', '入围', '其他'],
          }},

        {key: 'bid_info.bid_eval_method', width: 100, title: '评标办法', sortable: 'custom', type: 'type'},
        {
          key: 'bid_open_info.bid_unit_count', width: 60, title: '总投标家数', sortable: 'custom', type: 'number',
        },
        {
          key: 'bid_open_info.tech_bid_order', type: 'number', width: 80, title: '技术标排名', sortable: 'custom',
        },
        {
          key: 'bid_open_info.is_bid', width: 76, title: '是否中标', sortable: 'custom', type: 'boolean',
        },
        {key: 'bid_work_project_id', width: 80, title: '合同编审', type: 'type', sortable: 'custom',render: (h, {row})=>{
          if(row.bid_contract_project_id){
            return h('span',{style:"color:var(--success)"}, "查看");
          }
          return h('Button', {props: {size: 'small', type: 'success',icon:'md-send',disabled:!row.is_bid && row.bid_contract_project_id}, on: {click: ()=>{
            that.CreateNext(row);
          }}})
        }},
        {
          key: 'bid_open_info.is_exception', width: 76, title: '投标异常', sortable: 'custom', type: 'boolean',
        },
        {
          key: 'bid_bond.deposit_amount', type: 'number', option: {type: 'amount'}, width: 80, title: '投标保证金', sortable: 'custom',
        },
        {
          key: 'bid_files', type: 'file', width: 120, title: '投标文件', sortable: 'custom',
        },
        {
          key: 'bid_open_info.bid_open_record', type: 'file', width: 100, title: '开标记录', sortable: 'custom',
        },
        {key: 'tools', width: 100, title: '操作', sortable: false, fixed: 'right',
          render: (h, {row})=>{
            const buttons = [
              h('Button', {props: {size: 'small',icon:'md-create'}, on: {click: ()=>{
                that.Edit(row);
              }}}),
              h('Button', {props: {size: 'small',icon:'md-trash'}, on: {click: ()=>{
                that.handleDelete(row);
              }}}),
            ];
            return h('div', {class: 'flex-wrap flex-center split5'}, [buttons]);
          },
        },
      ];
    },
  },
  mounted() {
    this.$api.afterLogin(()=>{
      this.getData();
      this.getStatusCounts();
    });

    this.$nextTick(()=>{
      if (this.$refs && this.$refs.table && this.$refs.table.calcTableHeight) {
        this.$refs.table.calcTableHeight();
      }
    });
  },
};
</script>

  <style lange="less">
  .filter-box{
    height:50px;
  }

  .table-wrap{
    height:calc(100% - 50px);
    position: relative;
  }

  </style>
